var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-textarea',{staticClass:"c-textarea",attrs:{"label":_setup.props.label,"value":_setup.props.value,"disabled":_setup.props.disabled,"placeholder":_setup.props.placeholder,"outlined":"","dense":"","hide-details":""},on:{"input":function($event){return _setup.onInput($event)}}})
}
var staticRenderFns = []

export { render, staticRenderFns }